// ImageResultModal.jsx
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FaCopy } from "react-icons/fa";
import { ANIMAL_SPLIT_CORE } from "../constants";
import "./ImageResultModal.css";
import "../containers/ModalTheme.css";

export default function ImageResultModal({ show, onHide, result }) {
  const [copied, setCopied] = useState(false);

  if (!result) return null;

  const backendUrl = ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL;
  const fullUrl = backendUrl + result.proxyUrl;
  const imageUrl = fullUrl; // Use the full backend URL to render the image

  const handleCopyLink = () => {
    navigator.clipboard.writeText(fullUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Modal show={show} onHide={onHide} centered contentClassName="as-theme as-modal">
      <Modal.Header>
        <div className="as-modal-header-row">
          <div className="as-modal-title-row">
            <span className="as-modal-icon-badge" aria-hidden="true">✅</span>
            <Modal.Title>Upload Successful!</Modal.Title>
          </div>
          <button
            type="button"
            className="btn-close"
            onClick={onHide}
            aria-label="Close"
          />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="result-image-preview">
          <img src={imageUrl} alt="Uploaded" />
        </div>
        
        <div className="result-link-section">
          <label className="result-label">Image Link:</label>
          <div className="result-link-box">
            <code>{fullUrl}</code>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="as-modal-footer">
        <button className="btn btn-sm as-btn-soft" onClick={onHide}>
          Close
        </button>
        <button className="btn btn-sm as-btn-primary-gradient" onClick={handleCopyLink}>
          <FaCopy className="me-2" />
          {copied ? "Copied!" : "Copy Link"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
